import { defineMessages } from 'react-intl';

export default defineMessages({
	unlinkAllWarningModalTitle: {
		defaultMessage: 'Your help center needs at least one linked project',
		description: 'Title of the unlink all projects warning modal',
		id: 'projects.list.unlink.all.warning.modal.title',
	},
	unlinkAllWarningModalTitleGalaxia: {
		defaultMessage: 'Your help center needs at least one linked space',
		description: 'Title of the unlink all spaces warning modal',
		id: 'projects.list.unlink.all.warning.modal.title-galaxia',
	},
	unlinkAllWarningModalDescription: {
		defaultMessage:
			'To ensure that your customers can access relevant information and resources, at least one project needs to be linked to your help center. Uncheck a project and try again.',
		description: 'Description of the unlink all projects warning modal',
		id: 'projects.list.unlink.all.warning.modal.description',
	},
	unlinkAllWarningModalDescriptionGalaxia: {
		defaultMessage:
			'To ensure that your customers can access relevant information and resources, at least one space needs to be linked to your help center. Uncheck a space and try again.',
		description: 'Description of the unlink all spaces warning modal',
		id: 'projects.list.unlink.all.warning.modal.description-galaxia',
	},
	unlinkAllWarningModalOkButton: {
		defaultMessage: 'OK',
		description: 'Unlink all projects warning modal ok button',
		id: 'projects.list.unlink.all.warning.modal.ok.button',
	},
});
